<template>
  <div>
    <van-nav-bar
      :title="$t('app.timebao.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('app.common.pull_to_reload')":loosing-text="$t('app.common.release_to_reload')":loading-text="$t('app.common.loading')">
      <van-row >
        <van-col span="8"> </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>{{$t("app.timebao.current_asset")}}</h5>
            <p>{{ amount }}{{$t("app.common.currency")}}</p>
          </div>
        </van-col>
        <van-col span="8"
          ><div class="capital">
            <router-link to="/member/time_bao_details"
              ><h5 style="color: #1989fa">{{$t("app.timebao.bill")}}</h5></router-link
            >
          </div></van-col
        >
      </van-row>

      <van-row>
        <van-col span="8">
          <div class="capital">
            <h5>{{$t("app.timebao.last_8_hr")}}</h5>
            <p>{{ interestthis }}{{$t("app.common.currency")}}</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>{{$t("app.timebao.cumulate_income")}}</h5>
            <p>{{ interestamount }}{{$t("app.common.currency")}}</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>{{$t("app.timebao.annual_int")}}</h5>
            <p>{{ annual_interest_rate }}%</p>
          </div>
        </van-col>
      </van-row>
      <div class="capital-btn">
        <van-row>
          <van-col span="12">
            <van-button
              round
              type="danger"
              size="normal"
              @click="movein.status = true; movein.money=cash"
              style="height: 30px; width: 100px"
              >{{$t("app.timebao.transfer_in")}}</van-button
            >
          </van-col>
          <van-col span="12">
            <van-button
              round
              type="info"
              size="normal"
              @click="moveout.status = true; moveout.money=amount"
              style="height: 30px; width: 100px"
              >{{$t("app.timebao.transfer_out")}}</van-button
            >
          </van-col>
        </van-row>
      </div>
      <van-divider />
      <img :src="timebaoImage" style="width: 100%" />
    </van-pull-refresh>

    <!-- ==================== move IN confirm popup ========================== -->

    <van-dialog
      v-model="movein.status"
      :title="$t('app.timebao.transfer')"
      show-cancel-button
      :cancel-button-text="$t('app.common.cancel')"
      :confirm-button-text="$t('app.common.confirm')"
      :beforeClose="moveinBtn"
    >
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">{{$t("app.timebao.balance")}}:</p>
        </van-col>
        <van-col span="12"
          ><p style="padding-left: 30px; font-size: 14px">
            {{ cash }}{{$t("app.common.currency")}}
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <van-field
          type="number"
          v-model="movein.money"
          :label="$t('app.timebao.transferAm')"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>

    <!-- ==================== move OUT confirm popup ========================== -->

    <van-dialog
      v-model="moveout.status"
      :title="$t('app.timebao.transfer_from')"
      show-cancel-button
      :cancel-button-text="$t('app.common.cancel')"
      :confirm-button-text="$t('app.common.confirm')"
      :beforeClose="moveoutBtn"
    >
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">{{$t("app.timebao.transferable")}}</p>
        </van-col>
        <van-col span="12"
          ><p style="padding-left: 30px; font-size: 14px">
            {{ timebao_account }}{{$t("app.common.currency")}}
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <van-field
          type="number"
          v-model="moveout.money"
          :label="$t('app.timebao.transferring')"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "TimeBao",
  data() {
    return {
      isLoading: false,
      amount: 0,
      cash: 0,
      timebao_account: 0,
      interestthis: 0,
      interestamount: 0,
      annual_interest_rate: 0,
      timebaoImage: "",
      movein: {
        money: 0,
        status: false,
      },
      moveout: {
        money: 0,
        status: false,
      },
    };
  },
  computed: {},
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    mainMethod() {
      this.getTimebaoFund();
      this.getUserinfo();
    },
    onRefresh() {
      this.mainMethod();
      this.isLoading = false;
    },
    getTimebaoFund() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "timebao_fund",
            token: sessionStorage.getItem("token"),
            action: "queryfund",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            // that.account = resData.data.account;
            that.amount = resData.data.account.amount;
            that.interestthis = resData.data.account.interestthis;
            that.interestamount = resData.data.account.interestamount;
            that.timebaoImage = resData.data.image;
            that.annual_interest_rate = resData.data.annual_interest_rate;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          } else if (res.data.code == -1) {
            that.$logout(that.$t(res.data.msg));
          }
        });
    },

    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.movein.money = that.cash;
            that.timebao_account = res.data.data.timebao_accout;
            that.moveout.money = that.timebao_account;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },

    moveinBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.movein.money;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: this.$t('app.timebao.warning'),
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "timebao_fund",
                  token: sessionStorage.getItem("token"),
                  action: "movein",
                  amount: money,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.movein.money = 0;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(that.$t(res.data.msg));
                  done(false);
                }
              });
          }

          break;
        case "cancel":
          done();
          break;
      }
    },

    moveoutBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.moveout.money;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: this.$t('app.timebao.warning'),
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "timebao_fund",
                  token: sessionStorage.getItem("token"),
                  action: "moveout",
                  amount: money,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.moveout.money = 0;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(that.$t(res.data.msg));
                  done(false);
                }
              });
          }
          break;
        case "cancel":
          done();
          break;
      }
    },
  },
  mounted() {
    this.getTimebaoFund();
    this.getUserinfo();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.capital {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
}

.capital p {
  margin: 0;
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.capital-btn {
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TimeBao.vue